<template>
   <section class="loading-skeleton">
        <div class="line-loading-bar" v-if="loadingBar"></div>
        <div class="gif-container">
            <div class="gif-img"></div>
            <div class="gif-cred">
                <div class="gif-posted-by">
                    <div class="loading-skeleton-text"></div>
                </div>
                <div class="gif-posted-on">
                    <div class="loading-skeleton-text"></div>
                </div>
            </div>
            <div class="gif-options">
                <div class="btn btn-s loading-skeleton-btn"></div>
                <div class="btn btn-s loading-skeleton-btn"></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'loadingSkeleton',
    props: {
        loadingBar: Boolean
    }
}
</script>

<style>

</style>